import { IWalletContext, priceFormat } from "muminsmart-utils";
import React, { useMemo } from "react";
import { wallet } from "@/assets";

interface WalletBalanceProps {
  walletContexts: IWalletContext | null;
}

const WalletBalance: React.FC<WalletBalanceProps> = ({
  walletContexts,
}: WalletBalanceProps) => {
  const walletBalance = useMemo(() => {
    const userBalance = walletContexts?.user?.balance ?? 0;
    const sellersBalance =
      walletContexts?.sellers?.reduce(
        (acc, seller) => acc + (seller.balance ?? 0),
        0,
      ) ?? 0;

    return userBalance + sellersBalance;
  }, [walletContexts]);

  return (
    <div className="flex items-center border border-[#FEC424] rounded-md p-1 gap-1 shadow-sm">
      <img src={wallet} alt="Coin" width={24} height={24} />
      <span className="text-[#C49209] font-semibold text-sm">
        {priceFormat(walletBalance)}
      </span>
    </div>
  );
};

export default WalletBalance;
